"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Latitude = (function () {
    function Latitude(lat) {
        this.lat = lat;
        if (lat < -90 || lat > 90) {
            throw new RangeError("Unable to construct Lat: value must be included in range -90 to 90 (Given: " + lat + ")");
        }
        this.lat = lat;
    }
    Latitude.prototype.toJSON = function () {
        return this.lat;
    };
    return Latitude;
}());
exports.Latitude = Latitude;
//# sourceMappingURL=Latitude.js.map